import React from 'react';

const CategoryList = ({ categories, onEdit, onDelete }) => {
  if (!categories || categories.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">📁</div>
        <h3>No categories yet</h3>
        <p>Create your first category to get started</p>
      </div>
    );
  }

  // Separate main categories and subcategories
  const mainCategories = categories.filter(cat => cat.parent_id === null);
  const subcategories = categories.filter(cat => cat.parent_id !== null);

  return (
    <table className="data-table">
      <thead>
        <tr>
          <th>სახელი</th>
          <th>ტიპი</th>
          <th>ზეკატეგორია</th>
          <th>ქვეკატეგორია</th>
          <th>პროდუქტები</th>
          <th>მოქმედება</th>
        </tr>
      </thead>
      <tbody>
        {mainCategories.map((category) => (
          <React.Fragment key={category.id}>
            <tr style={{ backgroundColor: 'var(--light)' }}>
              
              <td style={{ fontWeight: 700 }}>{category.name}</td>
              <td>
                <span className="badge badge-primary">ზეკატეგორია</span>
              </td>
                                <td>-</td>

              <td>
                <span className="badge badge-success">
                  {category.subcategory_count} ქვეკატეგორია
                </span>
              </td>
              <td>
                <span className="badge badge-warning">
                  {category.product_count} პროდუქტი
                </span>
              </td>
              <td>
                <div className="action-buttons">
                  <button
                    className="action-btn edit"
                    onClick={() => onEdit(category)}
                  >
                    ✏️ შეცვლა
                  </button>
                  <button
                    className="action-btn delete"
                    onClick={() => onDelete(category.id)}
                  >
                    🗑️ წაშლა
                  </button>
                </div>
              </td>
            </tr>
            
            {/* Show subcategories under main category */}
            {subcategories
              .filter(sub => sub.parent_id === category.id)
              .map(subcategory => (
                <tr key={subcategory.id}>
                  <td style={{ paddingLeft: '2rem', fontWeight: 600 }}>
                    ↳ {subcategory.name}
                  </td>
                  <td>
                    <span className="badge badge-secondary">ქვეკატეგორია</span>
                  </td>
                  <td style={{ color: 'var(--gray)' }}>{subcategory.parent_name}</td>
                  <td>-</td>
                  <td>
                    <span className="badge badge-warning">
                      {subcategory.product_count} პროდუქტი
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn edit"
                        onClick={() => onEdit(subcategory)}
                      >
                        ✏️ შეცვლა
                      </button>
                      <button
                        className="action-btn delete"
                        onClick={() => onDelete(subcategory.id)}
                      >
                        🗑️ წაშლა
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default CategoryList;